module.exports = __webpack_public_path__ + "img/celtic2.9525f2b7.jpg";